/**
 * Combine multiple RuleTemplateModels to perform bulk operations,
 * and to find how to render the UI.
 *
 * @param {AbstractRuleTemplateModel[]} models - Models to use
 */
export default class CombinedRuleTemplateModel {
	constructor({ models }) {
		this._models = models;
	}

	makeSaveActionOn(ruleTemplatesWidget) {
		const forms = this._models.map((model) => model.getForm());
		forms.forEach((form) => form.submit());

		if (forms.some((form) => !form.validate())) {
			return ruleTemplatesWidget.makeNullRuleTemplateAction();
		}

		const actions = this._models.map((model) =>
			model.makeSaveActionOn(ruleTemplatesWidget),
		);

		return ruleTemplatesWidget.makeBulkEditAction(actions);
	}

	makeDeleteActionOn(ruleTemplatesWidget) {
		const actions = this._models.map((model) =>
			model.makeDeleteActionOn(ruleTemplatesWidget),
		);

		return ruleTemplatesWidget.makeBulkEditAction(actions);
	}

	renderButtonsFor(ruleTemplateWidgets) {
		if (this._models.some((model) => model.isOwnRule())) {
			return (html) => ruleTemplateWidgets.renderButtonsOwnOn(html);
		}

		if (this._models.some((model) => model.isInheritedRule())) {
			return (html) => ruleTemplateWidgets.renderButtonsInheritedOn(html);
		}

		return (html) => ruleTemplateWidgets.renderCreateButtonsOn(html);
	}
}
